import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { ReferFriend } from "src/types/graphql.d";

interface ReferFriendQueryData {
  referFriend?: ReferFriend | null;
}

interface ReferFriendVars {
  shop_type: string;
}

interface UseReferFriend {
  data: ReferFriendQueryData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

export const GET_REFER_FRIEND = gql`
  query referFriend($shop_type: String!) {
    referFriend(shop_type: $shop_type) {
      title
      subtitle
      link
      linkCTA
      image
    }
  }
`;

function useReferFriend(shopType: string): UseReferFriend {
  const { data, loading, error } = useQuery<
    ReferFriendQueryData,
    ReferFriendVars
  >(GET_REFER_FRIEND, {
    variables: { shop_type: shopType },
    skip: !shopType,
    fetchPolicy: "cache-first",
  });

  return { data, loading, error };
}

export { useReferFriend };
